export function FinancingSection() {
  return (
    <section id="financing" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/7da51d24271e17e1d7c2198da5f10508.jpg"
                alt="Financing options for Las Vegas remodeling projects"
                className="w-full h-full object-cover"
                title="RW Construction Financing Options"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-[#2C2C2C] text-white rounded-2xl p-8 shadow-xl">
              <div className="text-3xl font-bold mb-2">Flexible</div>
              <div className="text-sm">Payment Plans Available</div>
            </div>
          </div>

          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-2 h-2 bg-[#FF6B35] rounded-full"></div>
              <span className="text-[#FF6B35] text-sm font-semibold tracking-wider uppercase">Financing</span>
            </div>
            <h2 className="text-5xl font-bold text-[#2C2C2C] mb-6">Make Your Project Affordable</h2>
            <p className="text-gray-600 text-base leading-relaxed mb-6">
              Don't let budget constraints hold you back from your dream renovation. <strong>RW Construction Las Vegas LLC</strong> offers flexible financing options to make your remodeling project more accessible and manageable.
            </p>
            <p className="text-gray-600 text-base leading-relaxed mb-8">
              We work with trusted financing partners to provide competitive rates and terms that fit your budget. Whether it's a small repair or a complete property transformation, we'll help you find the right financing solution.
            </p>

            <div className="space-y-4 mb-8">
              <div className="flex items-start gap-4 bg-[#F8F6F3] rounded-xl p-5">
                <div className="w-10 h-10 bg-[#FF6B35] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-percent-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-[#2C2C2C] mb-1">Competitive Interest Rates</h4>
                  <p className="text-gray-600 text-sm">Low rates to keep your monthly payments affordable</p>
                </div>
              </div>

              <div className="flex items-start gap-4 bg-[#F8F6F3] rounded-xl p-5">
                <div className="w-10 h-10 bg-[#FF6B35] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-calendar-check-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-[#2C2C2C] mb-1">Flexible Terms</h4>
                  <p className="text-gray-600 text-sm">Choose payment plans that work with your financial situation</p>
                </div>
              </div>

              <div className="flex items-start gap-4 bg-[#F8F6F3] rounded-xl p-5">
                <div className="w-10 h-10 bg-[#FF6B35] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-speed-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-[#2C2C2C] mb-1">Quick Approval Process</h4>
                  <p className="text-gray-600 text-sm">Fast and easy application with quick decisions</p>
                </div>
              </div>
            </div>

            <button 
              onClick={() => {
                const element = document.getElementById('contact');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-[#FF6B35] text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-[#E55A2B] transition-all hover:scale-105 flex items-center gap-3 whitespace-nowrap cursor-pointer"
            >
              Learn About Financing
              <i className="ri-arrow-right-line text-xl"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
